import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'vis' })
export class VisPipe implements PipeTransform {
  transform(input: number): any {
    if (!input) {
      return '--';
    }
    const kmh = input / 1000;
    if (kmh < 0.1) {
      return '0';
    } else if (kmh < 1) {
      return kmh.toFixed(1);
    } else {
      return Math.round(kmh) + '';
    }
  }
}
